import { makeRequest } from './restcall';
import { ApiResponse } from './types';
import HttpMethod from './httpMethods';

export interface AuditListQuery {
    dateFrom?: string;
    dateTo?: string;
    userId?: string;
    organizationId?: string;
    module?: string;
    entityType?: string;
    actionType?: string;
    entityId?: string;
    correlationId?: string;
    page: number;
    pageSize: number;
}

export interface AuditListItem {
    id: string;
    occurredAtUtc: string;
    userId: string;
    userDisplayName: string;
    organizationId: string | null;
    module: string;
    entityType: string;
    entityId: string;
    actionType: string;
    description: string;
    correlationId: string;
    sourceDatabase: string;
}

export interface AuditDetail extends AuditListItem {
    changes: unknown;
}

export interface AuditListResponse {
    total: number;
    page: number;
    pageSize: number;
    items: AuditListItem[];
}

const QUERY_KEYS: (keyof AuditListQuery)[] = [
    'dateFrom',
    'dateTo',
    'userId',
    'organizationId',
    'module',
    'entityType',
    'actionType',
    'entityId',
    'correlationId',
    'page',
    'pageSize',
];

export function buildAuditListPath(query: AuditListQuery): string {
    const params = new URLSearchParams();
    QUERY_KEYS.forEach((key) => {
        const value = query[key];
        if (value === undefined || value === null || value === '') {
            return;
        }
        params.set(key, String(value));
    });
    return `/api/Audit?${params.toString()}`;
}

export async function getAuditListAPI(query: AuditListQuery): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, buildAuditListPath(query), {});
}

export async function getAuditDetailAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/Audit/${encodeURIComponent(id)}`, {});
}
